import { Box, HStack, Stack } from '@chakra-ui/react';
import { ColorPickerAtom } from '../../atoms/ColorPickerAtom';

interface ColorSettingsMoleculeProps {
  configs: any;
  onConfigChange: (key: string, value: string) => void;
}

export const ColorSettingsMolecule: React.FC<ColorSettingsMoleculeProps> = ({
  configs,
  onConfigChange,
}) => {
  return (
    <Box height="80vh" overflowY="auto">
      <Stack spacing={4}>
        <HStack
          p={4}
          borderWidth="1px"
          borderRadius="md"
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <ColorPickerAtom
            label="Primary Background Color"
            value={configs.primaryBgColor}
            onChange={color => onConfigChange('primaryBgColor', color)}
          />
        </HStack>
        <HStack
          p={4}
          borderWidth="1px"
          borderRadius="md"
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <ColorPickerAtom
            label="Secondary Background Color"
            value={configs.secondaryBgColor}
            onChange={color => onConfigChange('secondaryBgColor', color)}
          />
        </HStack>
        <HStack
          p={4}
          borderWidth="1px"
          borderRadius="md"
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <ColorPickerAtom
            label="Primary Accent Color"
            value={configs.primaryAccentColor}
            onChange={color => onConfigChange('primaryAccentColor', color)}
          />
        </HStack>
        <HStack
          p={4}
          borderWidth="1px"
          borderRadius="md"
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <ColorPickerAtom
            label="Secondary Accent Color"
            value={configs.secondaryAccentColor}
            onChange={color => onConfigChange('secondaryAccentColor', color)}
          />
        </HStack>
        <HStack
          p={4}
          borderWidth="1px"
          borderRadius="md"
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <ColorPickerAtom
            label="Tertiary Accent Color"
            value={configs.tertiaryAccentColor}
            onChange={color => onConfigChange('tertiaryAccentColor', color)}
          />
        </HStack>
        <HStack
          p={4}
          borderWidth="1px"
          borderRadius="md"
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <ColorPickerAtom
            label="Primary Text Color"
            value={configs.primaryTextColor}
            onChange={color => onConfigChange('primaryTextColor', color)}
          />
        </HStack>
        <HStack
          p={4}
          borderWidth="1px"
          borderRadius="md"
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <ColorPickerAtom
            label="Secondary Text Color"
            value={configs.secondaryTextColor}
            onChange={color => onConfigChange('secondaryTextColor', color)}
          />
        </HStack>
        <HStack
          p={4}
          borderWidth="1px"
          borderRadius="md"
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <ColorPickerAtom
            label="FAQ Category Title Color"
            value={configs.categoriesHeadingTextColor}
            onChange={color => onConfigChange('categoriesHeadingTextColor', color)}
          />
        </HStack>
        <HStack
          p={4}
          borderWidth="1px"
          borderRadius="md"
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <ColorPickerAtom
            label="News Headline Title Color"
            value={configs.newsHeadlineTextColor}
            onChange={color => onConfigChange('newsHeadlineTextColor', color)}
          />
        </HStack>
        <HStack
          p={4}
          borderWidth="1px"
          borderRadius="md"
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <ColorPickerAtom
            label="Pagination Text Color"
            value={configs.paginationSelectedPageTextColor}
            onChange={color => onConfigChange('paginationSelectedPageTextColor', color)}
          />
        </HStack>
        <HStack
          p={4}
          borderWidth="1px"
          borderRadius="md"
          mb={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <ColorPickerAtom
            label="Pagination Background Color"
            value={configs.paginationSelectedPageBgColor}
            onChange={color => onConfigChange('paginationSelectedPageBgColor', color)}
          />
        </HStack>
        paginationSelectedPageBgColor
      </Stack>
    </Box>
  );
};
